// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__vIO0L","made_with_love":"styles_made_with_love__8H37K","footer_nav":"styles_footer_nav__oBKkd"};